export default [
  'fetchProductElement',
  'fetchProductSlider',
]


// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/redux/product/productTypes.js